module.exports = __webpack_public_path__ + "822380b432988821e866ac347c7a1418.png";